import GetClassesRequestModel from '../../../generated/types/model/request/GetClassesRequestModel';

export default class GetClassesRequestViewModel extends GetClassesRequestModel {
  protected transformToDTO() {}
  protected transformFromDTO() {}
}
